import * as Yup from 'yup'

export const schema = Yup.object().shape({
  code: Yup.string()
    .min(6)
    .max(6)
    .matches(/^\d{6}$/, 'Incorrect verification code')
    .required('Verification code is required')
})
